export const menuData = [
    {
        title: "System",
        icon: "bx bx-laptop",
        sections: [
            {
                title: "Administration",
                items: [
                    { title: "Dashboard", path: "/", icon: "bx bxs-dashboard", module: "dashboard", actions: ["view"] },
                    { title: "User Profiles", path: "UserProfiles", icon: "bx bx-user", module: "users", actions: ["view"] },
                    { title: "Permission Manager", path: "PermissionManager", icon: "bx bx-shield-quarter", module: "users", actions: ["edit"] },
                    { title: "Company Profile", path: "CompanyProfile", icon: "bx bx-info-circle", module: "settings", actions: ["view"] },
                    { title: "Invoice Settings", path: "InvoiceSettings", icon: "bx bx-receipt", module: "settings", actions: ["edit"] },
                    { title: "Warranty Policies", path: "warranty-policies", icon: "bx bx-shield-quarter", module: "settings", actions: ["view"] },
                    { title: "System Data Usage", path: "SystemUsage", icon: "bx bx-data", module: "settings", actions: ["view"] },
                    { title: "Activity & Audit Logs", path: "SystemActivityLogs", icon: "bx bx-history", module: "settings", actions: ["view"] },
                    { title: "Ghost Item Detection", path: "GhostItemDetection", icon: "bx bx-ghost", module: "settings", actions: ["view"] },
                ]
            }
        ]
    },
    {
        title: "POS",
        icon: "bx bx-rfid",
        sections: [
            {
                title: "Sales & Terminal",
                items: [
                    { title: "Open POS", path: "posOpen", icon: "bx bx-calculator", module: "pos", actions: ["view", "create"] },
                    { title: "All Sales", path: "AllSales", icon: "bx bx-receipt", module: "sales", actions: ["view"] },
                    { title: "Warranties", path: "warranties", icon: "bx bx-shield-quarter", module: "dashboard", actions: ["view"] },
                ]
            }
        ]
    },
    {
        title: "Repairing",
        icon: "bx bx-wrench",
        sections: [
            {
                title: "Service Center",
                items: [
                    { title: "Repair Tickets Lookup", path: "repairs", icon: "bx bx-search-alt", module: "repair", actions: ["view"] },
                    { title: "New Repair Intake", path: "repairs/new", icon: "bx bx-plus-circle", module: "repair", actions: ["create"] },
                    { title: "Repair Dashboard", path: "repair/dashboard", icon: "bx bx-grid-alt", module: "dashboard", actions: ["view"] },
                ]
            },
            {
                title: "Catalog & Config",
                items: [
                    { title: "Quick Services Catalog", path: "quick-services", icon: "bx bx-list-ul", module: "repair", actions: ["view"] },
                ]
            }
        ]
    },
    {
        title: "Inventory",
        icon: "bx bx-package",
        sections: [
            {
                title: "Stock Management",
                items: [
                    { title: "Stock Overview", path: "StockOverview", icon: "bx bx-show-alt", module: "stock", actions: ["view"] },
                    { title: "Stock Valuations", path: "StockValuations", icon: "bx bx-line-chart", module: "stock", actions: ["view"] },
                    { title: "Virtual Warehouse", path: "virtual-warehouse", icon: "bx bx-buildings", module: "stock", actions: ["view"] },
                    { title: "Adjustment List", path: "StockAdjustments", icon: "bx bx-history", module: "stock", actions: ["view"] },
                    { title: "Batch Price Update", path: "BatchPriceUpdate", icon: "bx bx-purchase-tag", module: "stock", actions: ["edit"] },
                    { title: "Batch No. Price Update", path: "BatchNumberPriceUpdate", icon: "bx bx-purchase-tag", module: "stock", actions: ["edit"] },
                    { title: "Stock Damage & Write-Off", path: "StockDamageManager", icon: "bx bx-error-alt", module: "stock", actions: ["edit"] },
                ]
            },
            {
                title: "Barcode Ops",
                items: [
                    { title: "Label Print", path: "LabelPrint", icon: "bx bx-printer", module: "barcode", actions: ["view"] },
                    { title: "Barcode Templates", path: "BarcodeTemplateManager", icon: "bx bx-barcode", module: "barcode", actions: ["edit"] },
                ]
            },
            {
                title: "Master Data",
                items: [
                    { title: "Product Catalog", path: "ProductCatalog", icon: "bx bx-grid-alt", module: "items", actions: ["view"] },
                    { title: "Item Registry", path: "ListItems", icon: "bx bx-list-ul", module: "items", actions: ["view"] },
                    { title: "Add Item", path: "AddItems", icon: "bx bx-plus-circle", module: "items", actions: ["create"] },
                    { title: "Brands", path: "ListAllBrands", icon: "bx bx-tag", module: "items", actions: ["view"] },
                    { title: "Phone Models", path: "phone-models", icon: "bx bx-mobile-alt", module: "items", actions: ["view"] },
                    { title: "Units", path: "ListUnits", icon: "bx bx-unite", module: "units", actions: ["view"] },
                    { title: "Attributes", path: "Attributes", icon: "bx bx-tag-alt", module: "items", actions: ["view"] },
                ]
            }
        ]
    },
    {
        title: "CRM",
        icon: "bx bx-group",
        sections: [
            {
                title: "Partners",
                items: [
                    { title: "Suppliers", path: "ListAllSuppliers", icon: "bx bx-store", module: "supplier", actions: ["view"] },
                    { title: "Customers", path: "ListAllCustomers", icon: "bx bx-user-pin", module: "customers", actions: ["view"] },
                    { title: "Device Hub", path: "customer-device-hub", icon: "bx bx-mobile-alt", module: "customers", actions: ["view"] },
                ]
            },
            {
                title: "Workforce",
                items: [
                    { title: "Employees", path: "ListAllEmployees", icon: "bx bx-user-check", module: "employee", actions: ["view"] },
                    { title: "Shift Management", path: "shift-management", icon: "bx bx-time-five", module: "employee", actions: ["view"] },
                ]
            }
        ]
    },
    {
        title: "Procurement",
        icon: "bx bx-cart-add",
        sections: [
            {
                title: "Purchases",
                items: [
                    { title: "Procurement Center", path: "ProcurementCenter", icon: "bx bx-list-ol", module: "purchase", actions: ["view"] },
                    { title: "Supplier Returns (Virtual Warehouse)", path: "virtual-warehouse", icon: "bx bx-buildings", module: "purchase", actions: ["view"] },
                ]
            },
            {
                title: "Payments",
                items: [
                    { title: "View Payments", path: "ListPayments", icon: "bx bx-credit-card", module: "payments", actions: ["view"] },
                    { title: "Add Payment", path: "AddPayments", icon: "bx bx-plus", module: "payments", actions: ["create"] },
                ]
            }
        ]
    },
    {
        title: "Accounts",
        icon: "bx bx-wallet",
        sections: [
            {
                title: "Financials",
                items: [
                    { title: "Company Accounts", path: "ListCompanyAccounts", icon: "bx bx-building", module: "companyAccount", actions: ["view"] },
                    { title: "Customer Accounts", path: "ListCustomersAccounts", icon: "bx bx-user", module: "customersAccount", actions: ["view"] },
                    { title: "Supplier Accounts", path: "ListSuppliersAccounts", icon: "bx bx-store", module: "supplierAccount", actions: ["view"] },
                    { title: "Employees Account", path: "ListEmployeesAccounts", icon: "bx bxs-user-check", module: "employeeAccount", actions: ["view"] },
                    { title: "Expense Manager", path: "ExpenseManager", icon: "bx bx-money-withdraw", module: "companyAccount", actions: ["view"] },
                ]
            }
        ]
    },
    {
        title: "Intelligence",
        icon: "bx bx-brain",
        sections: [
            {
                title: "Insights",
                items: [
                    { title: "Report Portal", path: "reports/portal", icon: "bx bx-spreadsheet", module: "settings", actions: ["view"] },
                    { title: "Owner Flash", path: "reports/portal?view=owner", icon: "bx bxs-zap", module: "settings", actions: ["view"] },
                    { title: "Forecasting", path: "reports/portal?view=forecast", icon: "bx bx-line-chart", module: "settings", actions: ["view"] },
                    { title: "P&L Statement", path: "reports/profit-loss", icon: "bx bx-dollar-circle", module: "settings", actions: ["view"] },
                ]
            },
            {
                title: "Audit",
                items: [
                    { title: "Customer Value", path: "reports/portal?view=customer", icon: "bx bx-user-voice", module: "settings", actions: ["view"] },
                    { title: "Supplier Exposure", path: "reports/portal?view=supplier", icon: "bx bx-archive-out", module: "settings", actions: ["view"] },
                    { title: "Stock Forensic", path: "reports/portal?view=stock", icon: "bx bx-search-alt", module: "settings", actions: ["view"] },
                    {
                        title: "Zakat Audit",
                        path: "zakat-management",
                        icon: "bx bx-heart-square", // Religious/Charity symbol in Boxicons
                        module: "zakat",
                        actions: ["view", "create"]
                    },
                ]
            }
        ]
    }
];
